import Vue from "vue";
import VueRouter from "vue-router";
import { redirections } from "@/router/redirections";
import { countries } from "@/store/countries";

Vue.use(VueRouter);

const routes = [
  //redirections

  ...redirections,

  {
    path: "/land23",
    name: "home1",

    component: () =>
      import(/* webpackChunkName: "home" */ "../views/home3.vue"),
    meta: {
      title: "1app | Global banking for Nigerians",
    },
  },
  {
    path: "/",
    children: [
      {
        path: "/cross-border",
        name: "cross-border",

        component: () =>
          import(
            /* webpackChunkName: "cross-border" */ "../views/cross-border/cross-border.vue"
          ),
        meta: {
          title: "1app | Cross-Border",
        },
      },
      {
        path: "/developer",
        name: "developer",

        component: () =>
          import(
            /* webpackChunkName: "developer" */ "../views/developer/developer.vue"
          ),
        meta: {
          title: "Developer | 1app",
        },
      },
      {
        path: "/bill-payment",
        name: "bill-payment",

        component: () =>
          import(/* webpackChunkName: "bills" */ "../views/bills/bills.vue"),
        meta: {
          title: "Bill Payment | 1app",
        },
      },
      {
        path: "/about-us",
        name: "about-us",

        component: () =>
          import(
            /* webpackChunkName: "about-us" */ "../views/about-us/about-us.vue"
          ),
        meta: {
          title: "About US | 1app",
        },
      },
      {
        path: "/cards",
        name: "cards",

        component: () =>
          import(/* webpackChunkName: "card" */ "../views/card/card.vue"),
        meta: {
          title: "Cards | 1app",
        },
      },
      {
        path: "/why-us",
        name: "why-us",

        component: () =>
          import(/* webpackChunkName: "why-s" */ "../views/why-us/why-us.vue"),
        meta: {
          title: "Why Us | 1app",
        },
      },
      {
        path: "/faq",
        name: "faq",

        component: () =>
          import(/* webpackChunkName: "faq" */ "../views/faq.vue"),
        meta: {
          title: "Frequently Asked Questions | 1app",
        },
      },
      {
        path: "/aggregator",
        name: "aggregator",

        component: () =>
          import(/* webpackChunkName: "faq" */ "../views/aggregator.vue"),
        meta: {
          title: "Aggregator | 1app",
        },
      },
      {
        path: "/pricing",
        name: "pricing",

        component: () =>
          import(/* webpackChunkName: "faq" */ "../views/pricing.vue"),
        meta: {
          title: "Pricing | 1app",
        },
      },
      {
        path: "/land2",
        name: "home2",

        component: () =>
          import(/* webpackChunkName: "home2" */ "../views/home.vue"),
        meta: {
          title: "1app | Global banking for Nigerians",
        },
      },
      {
        path: "/cheap",
        name: "home3",

        component: () =>
          import(/* webpackChunkName: "home2" */ "../views/home2.vue"),
        meta: {
          title: "1app | Global banking for Nigerians",
        },
      },
      {
        path: "/pay/:id",
        name: "pay",

        component: () =>
          import(/* webpackChunkName: "pay" */ "../views/pay.vue"),
        meta: {
          title: "Payment Link | 1app",
        },
      },
      {
        path: "/payme/:id",
        name: "payme",

        component: () =>
          import(/* webpackChunkName: "payme" */ "../views/pay-page.vue"),
        meta: {
          title: "Get Paid | 1app",
        },
      },
      {
        path: "/download",
        name: "download",

        component: () =>
          import(/* webpackChunkName: "download" */ "../views/download.vue"),
        meta: {
          title: "Download | 1app",
        },
      },
      {
        path: "/rateus",
        name: "rateus",

        component: () =>
          import(/* webpackChunkName: "download" */ "../views/rateus.vue"),
        meta: {
          title: "Rate Us | 1app",
        },
      },
      {
        path: "/contact",
        name: "contact",

        component: () =>
          import(/* webpackChunkName: "download" */ "../views/contact-us.vue"),
        meta: {
          title: "Contact Us | 1app",
        },
      },
      {
        path: "/why/:id?",
        name: "why",

        component: () =>
          import(/* webpackChunkName: "why" */ "../views/why.vue"),
        meta: {
          title: "Why choose Us | 1app",
        },
      },
      {
        path: "/what/:id?",
        name: "what",

        component: () =>
          import(/* webpackChunkName: "what" */ "../views/what.vue"),
        meta: {
          title: "1app | What we do",
        },
      },
      {
        path: "/request-access",
        name: "requestAccess",

        component: () =>
          import(
            /* webpackChunkName: "request-access" */ "../views/requestAccess.vue"
          ),
        meta: {
          title: "Request access to our APIs | 1app",
        },
      },
      {
        path: "/terms-and-conditions",
        name: "terms",

        component: () =>
          import(/* webpackChunkName: "terms" */ "../views/terms.vue"),
        meta: {
          title: "1app | Terms & Conditions",
        },
      },
      {
        path: "/privacy",
        name: "privacy",

        component: () =>
          import(/* webpackChunkName: "privacy" */ "../views/privacy.vue"),
        meta: {
          title: "1app | Privacy Policy ",
        },
      },
      // {
      //   path: "/testimonial",
      //   name: "testimonial",

      //   component: () =>
      //     import(
      //       /* webpackChunkName: "testimonial" */ "../views/video-testimonial.vue"
      //     ),
      //   meta: {
      //     title: "Video Testimonial | 1app",
      //   },
      // },
      {
        path: "/legal",
        name: "legal",

        component: () =>
          import(/* webpackChunkName: "legal" */ "../views/legal.vue"),
        meta: {
          title: "Legal | 1app",
        },
      },
      {
        path: "/gc/:redeemCode",
        name: "giftcard",

        component: () =>
          import(/* webpackChunkName: "giftcard" */ "../views/giftcard.vue"),
        meta: {
          title: "Redeem Gift Card | 1app",
        },
      },
      {
        path: "/ticket/:eventid",
        name: "eticket",

        component: () =>
          import(/* webpackChunkName: "eticket" */ "../views/eticket.vue"),
        meta: {
          title: "Event Ticket | 1app",
        },
      },
      {
        path: "/veremail/:token",
        name: "veremail",

        component: () =>
          import(
            /* webpackChunkName: "veremail" */ "../views/verify-email.vue"
          ),
        meta: {
          title: "1app | Verify Email",
        },
      },
      {
        path: "/sos",
        name: "sos",
        component: () =>
          import(/* webpackChunkName: "sos" */ "../views/sos.vue"),
        meta: {
          title: "1app | SOS",
        },
      },
      // {
      //   path: "/ke",
      //   name: "ke",
      //   component: () =>
      //     import(/* webpackChunkName: "kenya" */ "../views/ke/kenya.vue"),
      //   meta: {
      //     title: "1app | Financial Infrastructure for Kenyans",
      //   },
      // },
      {
        path: "/ng",
        name: "ng",
        component: () =>
          import(/* webpackChunkName: "ng" */ "../views/home/home.vue"),
        meta: {
          title: "Global banking for Nigerians | 1app ",
        },
      },
      {
        path: ":country?",
        name: "home",
        component: () =>
          import(
            /* webpackChunkName: "home" */ "../views/beta-form/beta-form.vue"
          ),
        meta: {
          title: "Global banking for Nigerians | 1app ",
        },
        beforeEnter: (to, from, next) => {
          const exist = countries.find(
            (e) => e.alpha3?.toLowerCase() == to.params.country
          );
          if (!exist) {
            next({ name: "pay-me", params: { username: to.params.country } });
          }
          next();
        },
      },
    ],
    component: () =>
      import(/* webpackChunkName: "index" */ "../views/index.vue"),
  },
  {
    path: ":username",
    name: "pay-me",
    component: () => import(/* webpackChunkName: "pay-me" */ "../views/pay-me"),
    meta: {
      title: "1app: Everything Payment",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;